<template>
  <div :class="['loading-overlay', {}, props.className]" :style="[props.inlineStyles]">
    <Loading :isPulse="props.isPulse" :isCircleFade="props.isCircleFade" :isFlow="props.isFlow" :isWave="props.isWave" />
  </div>
</template>

<script setup>
const componentName = "LoadingOverlay";

const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {
      return {
        // Style
      };
    },
  },
  isPulse: {
    type: Boolean,
  },
  isCircleFade: {
    type: Boolean,
  },
  isFlow: {
    type: Boolean,
  },
  isWave: {
    type: Boolean,
  },
});
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.loading-overlay {
  /* Parent style   ------------------------------ */
  animation-name: fadeIn;
  animation-duration: 0.3s;
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, rgba(20, 0, 41, 0.75), rgba(0, 6, 30, 0.75));

  /* Children style ------------------------------ */
  /* Modifier style ------------------------------ */
}
</style>
